const ZINDEXES = {
    TABLE_HEADER: 10,
    SIDEBAR: 20,
    MODAL: 1000,
    DROPDOWN: 1001,
    TOAST: 1100,
};

export default ZINDEXES;
